
import { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { BulletList } from 'react-content-loader';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { dataLoading } from '../../../assets/assets';
import { saveCourseData } from '../../../Redux/Slices/MainSlice';
import httpApiCall from '../../../service/api.service';
import { accessTokenLogin, getStorageValue } from '../../../service/shared.service';
import toastr from '../../elements/toast';
import './quiz.scss';

interface question_list {
   answers: [
      {
         id: number,
         answer: string
      }
   ]
   correct_answer_id : number,
   course_id : number,
   question_id : number,
   question_name: string,
   index: number,
}

const CourseQuiz = () => {
   const [shimmer, setShimmer] = useState(false);
   // const [isupdate, setIsUpdate] = useState(false);
   const [course_id, setCourseId] = useState(0);
   const [quizOutput, setQuizOutput] = useState({
      is_badge_earn: 0,
      course_score: 0
   });
   const [checked, setChecked] = useState(0);
   const [training_name, setTrainingName] = useState('');
   let [selectedAnswerIds, setSelectedAnswerIds] = useState<any>();
   const [locked_answer, setLockedAnswer] = useState(null);
   const [progress, setProgress] = useState(0);
   let [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
   const [showCelebrations, setShowCelebrations] = useState(false);
   let [questionList, setQuestionList] = useState<Array<question_list>>([]);
   const [selectedQuestion, setSelectedQuestion] = useState([]);
   const [quizResults, setQuizResults] = useState([]);
   const [isActive, setIsActive] = useState();
   const params = useParams();
   const toastrService = new toastr(true);
   const navigate = useNavigate();
   const dispatch = useDispatch();

   const courseData = useSelector((state: any) => state?.APIData?.courseData)
   let getProfile: any = getStorageValue("partnerProfile");
	if (getProfile && getProfile.length) {
		getProfile = getProfile[0];
	}

   useEffect(() => {
      if (!courseData || (courseData && !courseData.length)) {
         getCourses();
      } else {
         courseData.filter((ele: any) =>  {
            if (ele['course_id'] == params['course_id']) {
               setTrainingName(ele['course_training_name']);
            }
         })
      }
      getQuizData();
   }, [courseData])

   const getCourses  = async () => {
      const body = {
         access_token: getProfile.access_token
      }
      setShimmer(true);
      await httpApiCall({ api: "get_partner_courses", type: "post", body }).then(data => {
         dispatch(saveCourseData(data.data));
         setShimmer(false);
         if (!data.is_error) {
            data.data.filter((ele: any) =>  {
               
               if (ele['course_id'] == course_id) {
                  setTrainingName(ele['course_training_name']);
               }
            })
         } else {
            toastrService.showError('Something went wrong');
         }
      })
   }

   const getQuizData = async () => {
      if (params && params['course_id']) {
         const body = {
            access_token: getProfile.access_token,
            course_id: params['course_id']
         }
         setCourseId(Number(params['course_id']));
         setShimmer(true);
         await httpApiCall({ api: "get_particular_quiz_data", type: "post", body }).then(data => {
            setShimmer(false);
            if (!data.is_error) {
               questionList = data.data;
               const selectedAnswerIds: any = new Array(data.data.length).fill(0);
               setSelectedAnswerIds(selectedAnswerIds);
              //  console.log(selectedAnswerIds);
               setQuestionList(data.data);
               questionList.filter((ele: any, i = 0) => {
                  ele.index = i++;
                  return ele;
               })
              //  console.log(questionList);
            } else {
               toastrService.showError('Invalid course selected');
            }
         })
      } else {
         toastrService.showError('Invalid course selected');
         navigate('/app/courses')
      }
   }

   const back = () => {
      navigate(`/app/courses/details/${course_id}`);    
   }

   const nextQuestion = (data: any) => {
      if (selectedQuestion[currentQuestionIndex + 1] && selectedQuestion[currentQuestionIndex + 1]['answer_id']) {
        setValue(selectedQuestion[currentQuestionIndex + 1]['answer_id']);
      }else{
         const selectedQ:any = selectedQuestion;
         selectedQ.splice(currentQuestionIndex, 1, { answer_id: checked });
         setSelectedQuestion(selectedQ);
         const isCorrect = data.correct_answer_id == locked_answer ? 1 : 0;
         const quizR: any = quizResults;
         quizR.splice(currentQuestionIndex, 1, { question: data.question_id, is_correct: isCorrect });
         setQuizResults(quizR);
      }
      if (currentQuestionIndex < questionList.length - 1) {
        const prog = ((currentQuestionIndex + 1) / questionList.length) * 100;
        setProgress(prog);
        // console.log(progress,"progress");
        
        setCurrentQuestionIndex(++currentQuestionIndex);
      } else {
        setProgress(100);
        addCourseData();
      }
      if (selectedQuestion[currentQuestionIndex] && selectedQuestion[currentQuestionIndex]['answer_id'] != isActive) {
        setLockedAnswer(null);
      }
      // setIsUpdate(false);
      // console.log(quizResults,"quizResults");
      
   }

   const addCourseData = async () => {
      const body = {
        course_id: Number(course_id),
        quiz_result: quizResults,
        access_token: getProfile.access_token
      }
      await httpApiCall({ api: "add_course_badges", type: "post", body }).then((res: any) => {
        if (!res.is_error) {
          setQuizOutput(res.data);
          setShowCelebrations(true);
         //  quizOutput.course_score = (quizResults.filter((result :any)=>(result.is_correct == 1))).length;
         //  quizOutput.is_badge_earn = res.data[0]?.is_badge_earn
         //  setQuizOutput(quizOutput)
          if (res?.data?.course_score < questionList.length) {
            const prog = (res?.data?.course_score/questionList.length) * 100;
            setProgress(prog);
            // console.log(progress,"progress");
          }
        } else {
            toastrService.showError('Somethig went wrong while fetching badges data');
            return ;
        }
      })
   }

   const previousQuestion = () => {
      if (currentQuestionIndex > 0) {
         setCurrentQuestionIndex(currentQuestionIndex - 1)
         const prog = progress - 100 / questionList.length;
         setProgress(prog);
         // setIsUpdate(false);
         setValue(selectedQuestion[currentQuestionIndex] && selectedQuestion[currentQuestionIndex]['answer_id']);
       }
   }

   const navigateToNext = () => {
      const listdata :any[] =courseData
      const idIndex = listdata.findIndex((ele: any) =>  (ele['course_id'] == params['course_id']))
      const newIndex = idIndex +1
      const newCourseId = courseData[newIndex].course_id
      navigate(`/app/courses/details/${newCourseId}`);  
      accessTokenLogin();
   }

   const setValue = (val: any) => {
      setChecked(val);
      setLockedAnswer(val);
      setIsActive(val);
   }

   const getAnswers = (e: any, value: any) => {

      setLockedAnswer(null);
      // setIsUpdate(true);
      if (selectedQuestion[currentQuestionIndex] && selectedQuestion[currentQuestionIndex]['answer_id']) {
         const selectedQ: any = selectedQuestion;
         selectedQ.splice(currentQuestionIndex, 1, { answer_id: e.target.id });
         setSelectedQuestion(selectedQ);
        const isCorrect = value.correct_answer_id == e.target.id ? 1 : 0;
        const quizRez: any = selectedQuestion;
        quizRez.splice(currentQuestionIndex, 1, { question: value.question_id, is_correct: isCorrect });
        setQuizResults(quizRez);
      }
      setValue(e.target.id);
   }

   const tryAgain = () => {
      setShowCelebrations(!showCelebrations);
      setQuizResults([]);
      setLockedAnswer(null);
      setCurrentQuestionIndex(0);
      setProgress(0);
      setSelectedQuestion([]);
      getQuizData();
   }

   return (
     <>
       <div className="quiz">
         <div className="quiz-back">
           <div className="back--btn cursor">
             <a onClick={() => back()}>
               <span className="icon"></span>Back to course
             </a>
           </div>
         </div>
         <div className="quiz-main">
           <div className={`quiz-wrapper ${quizOutput.course_score == 4 || quizOutput.course_score == 5 || quizOutput.course_score == 8 ? '-heightend' :''}`}>
             <div className="heading">
               <h5>{training_name}</h5>
               {/* <p>Course {cousrseOrder}</p> */}
             </div>
             <div
               className={
                 quizOutput &&
                 quizOutput["course_score"] < questionList.length &&
                 showCelebrations
                   ? "progress redprogress"
                   : "progress"
               }
             >
               <div
                 className={`progress-bar ${quizOutput &&
                  quizOutput["course_score"] == questionList.length ? "greenprogress" : "quiz-bar"}`}
                 role="progressbar"
                 style={{ width: progress + "%" }}
               ></div>
             </div>

             <div className="questions">
               <>
                 {shimmer && (
                   <div className="">
                     {/* <img src={dataLoading} alt="" /> */}
                     <BulletList />
                   </div>
                 )}
                 {!shimmer &&
                   questionList &&
                   questionList.length > 0 &&
                   !showCelebrations && (
                     <div>
                       <p>
                         Question{" "}
                         <b style={{ color: "#000" }}>
                           {" "}
                           {questionList[currentQuestionIndex]["index"] + 1}
                         </b>{" "}
                         of {questionList.length}
                       </p>
                        <h5>
                          {questionList[currentQuestionIndex]["question_name"]}
                        </h5>
                        <div className="mcq">
                          {/* {questionList} */}
                          {questionList[currentQuestionIndex]["answers"].map(
                            (option, index) => (
                              <div>
                                <label
                                  key={index}
                                  className={`label_input ${selectedAnswerIds[currentQuestionIndex] ==
                                    option.id
                                    ? "d-inline-flex active"
                                    : "d-inline-flex"
                                    }`}>
                                  <input
                                    className="domain_checkbox"
                                    name="group1"
                                    type="radio"
                                    value={selectedAnswerIds[currentQuestionIndex]}
                                    checked={
                                      selectedAnswerIds[currentQuestionIndex] ==
                                        option.id
                                        ? true
                                        : false
                                    }
                                    onChange={(event) => {
                                      getAnswers(
                                        event,
                                        questionList[currentQuestionIndex]
                                      );
                                      selectedAnswerIds[currentQuestionIndex] =
                                        event.target.id;
                                    }}
                                    id={option.id + ""}
                                  />
                                  <p className="answers m-0 p-0 ms-2 d-inline-block">
                                    {option.answer}
                                  </p>
                                </label>
                              </div>

                            )
                          )}
                        </div>
                       {
                         <div
                           className={
                             currentQuestionIndex > 0
                               ? "prev control"
                               : "control"
                           }
                         >
                           {currentQuestionIndex > 0 && (
                             <button
                               className="back cursor"
                               onClick={() => previousQuestion()}
                             >
                               <span className="me-2">
                                 <i className="arrow left"></i>
                               </span>
                               Back
                             </button>
                           )}
                           <button
                             id={"next-question"}
                             disabled={
                               selectedAnswerIds[currentQuestionIndex] == 0
                             }
                             className={
                               selectedAnswerIds[currentQuestionIndex] != 0
                                 ? "next text-end marked"
                                 : "next text-end"
                             }
                             onClick={() =>
                               nextQuestion(questionList[currentQuestionIndex])
                             }
                           >
                             Next
                           </button>
                         </div>
                       }
                     </div>
                   )}
               </>
             </div>
             {showCelebrations && (
               <div className={`celebrations ${quizOutput && quizOutput["course_score"] == questionList.length ? "data_chnge" : ""}`}>
                 <div className="score">
                   <p className={quizOutput.is_badge_earn ? "earnbadge" : ""}>
                     <span
                       style={{
                         color: !quizOutput.is_badge_earn ? "#f00" : "#18b557",
                         fontSize: !quizOutput.is_badge_earn ? "14px" : "15px",
                         fontWeight: !quizOutput.is_badge_earn ? "400" : "800",
                       }}
                     >
                       {quizOutput.course_score}
                     </span>{" "}
                     out of {selectedQuestion.length}
                   </p>
                 </div>
                 {quizOutput && quizOutput.is_badge_earn != 0 && (
                   <div>
                     <div className="d-flex align-items-center justify-content-center mt-4">
                       <div className="img-wrapper">
                         <img
                           src="app/assets/png/courses/unlocked.png"
                           alt=""
                           className="cele-img"
                         />
                         {/* <ng-lottie [options]="options" (animationCreated)="onAnimate($event)">
                                       </ng-lottie> */}
                       </div>
                       <div className="celebrations-content">
                         <p>Celebrations are in order!</p>
                         <h5>
                           You've just unlocked a well-deserved badge of
                           accomplishment.
                         </h5>
                       </div>
                     </div>
                     <div className="next-course">
                       <button onClick={() => navigateToNext()}>
                         Next Course
                       </button>
                     </div>
                   </div>
                 )}
                 {!quizOutput.is_badge_earn && (
                   <div className="minimum">
                     <img
                       src="app/assets/png/courses/minimum.png"
                       alt=""
                       className="minimum-img"
                     />
                     <div className="minimum-content">
                       <p>
                         Your journey is important to us. <br />
                         To complete this course,{" "}
                         <span className="blue">
                           {" "}
                           a minimum score of {course_id == 5 ? 5 : 4} is
                           needed.{" "}
                         </span>
                       </p>
                       <h5>
                         Feel free to retry whenever you're ready. We believe in
                         your potential and are here to support your learning
                         every step of the way.
                       </h5>
                     </div>
                     <div className="minimum-footer">
                       <div>
                         <button className="retry" onClick={() => tryAgain()}>
                           Retry
                           <span className="ms-2">
                             <svg
                               width="17"
                               height="18"
                               viewBox="0 0 17 18"
                               fill="none"
                               xmlns="http://www.w3.org/2000/svg"
                             >
                               <path
                                 d="M3.04813 5.01204C2.94188 4.98394 2.84311 4.93282 2.7588 4.86232C2.67449 4.79181 2.60671 4.70364 2.56025 4.60404C2.51379 4.50444 2.48978 4.39585 2.48993 4.28594C2.49009 4.17604 2.51439 4.06751 2.56113 3.96804L4.22113 0.433043C4.28159 0.303592 4.37777 0.194104 4.49835 0.117463C4.61893 0.0408222 4.75889 0.000217947 4.90177 0.000428057C5.04464 0.000638167 5.18448 0.041654 5.30484 0.118649C5.42519 0.195644 5.52105 0.305415 5.58113 0.435043L6.31313 2.00404C6.33927 1.99356 6.36598 1.98454 6.39313 1.97704C8.12014 1.51451 9.95132 1.6327 11.6045 2.3134C13.2578 2.99411 14.6413 4.19954 15.5419 5.74399C16.4426 7.28844 16.8104 9.08619 16.5887 10.8603C16.3669 12.6343 15.568 14.2863 14.315 15.5616C13.0619 16.8369 11.4243 17.6647 9.65442 17.9176C7.88453 18.1705 6.08058 17.8344 4.52052 16.9611C2.96046 16.0878 1.73086 14.7257 1.02116 13.0847C0.311471 11.4437 0.161068 9.61492 0.593129 7.88004C0.61703 7.78444 0.659526 7.69448 0.718193 7.6153C0.77686 7.53612 0.850547 7.46928 0.935049 7.41858C1.01955 7.36788 1.11321 7.33431 1.21068 7.31981C1.30815 7.30531 1.40753 7.31014 1.50313 7.33404C1.59873 7.35794 1.68869 7.40044 1.76787 7.45911C1.84705 7.51777 1.9139 7.59146 1.9646 7.67596C2.0153 7.76046 2.04886 7.85412 2.06336 7.9516C2.07787 8.04907 2.07303 8.14844 2.04913 8.24404C1.69875 9.65217 1.81856 11.1363 2.3903 12.47C2.96203 13.8036 3.95431 14.9137 5.21577 15.6309C6.47724 16.348 7.93866 16.6329 9.37712 16.442C10.8156 16.2511 12.1521 15.595 13.1829 14.5737C14.2137 13.5523 14.8821 12.2219 15.0862 10.7852C15.2904 9.3486 15.019 7.88463 14.3135 6.61661C13.608 5.34859 12.5071 4.34613 11.1787 3.76213C9.85035 3.17813 8.36743 3.04465 6.95613 3.38204L7.69613 4.96504C7.75671 5.09433 7.77912 5.23822 7.76075 5.3798C7.74237 5.52139 7.68396 5.65479 7.59238 5.76432C7.5008 5.87386 7.37987 5.95498 7.24378 5.99815C7.10769 6.04133 6.9621 6.04476 6.82413 6.00804L3.04813 5.01204Z"
                                 fill="white"
                               />
                             </svg>
                           </span>
                         </button>
                       </div>
                       <div>
                         <button
                           className="new-course cursor"
                           onClick={() => back()}
                         >
                           Back to Course
                         </button>
                       </div>
                     </div>
                   </div>
                 )}
               </div>
             )}
           </div>
         </div>
       </div>
     </>
   );
}

export default CourseQuiz;
